import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import lodash from 'lodash'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import CKEditor from '@ckeditor/ckeditor5-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/mixins';
import '@/vee-validate'
import VueMeta from 'vue-meta'
import { i18n } from './translate'
import OtpInput from "@bachdgvn/vue-otp-input";
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
const options = {
  confirmButtonColor: '#0057A1',
  cancelButtonColor: '#ff7674',
};

Vue.use(VueSweetalert2, options);

Vue.component("v-otp-input", OtpInput);


Vue.use(VueMeta)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.prototype._ = lodash
Vue.use(CKEditor);

if (process.env.NODE_ENV !== 'development'){
  console.log = function () {}
}

import '@/helpers/common-components.js';
Vue.config.productionTip = false
const EventBus = new Vue()
Object.defineProperties(Vue.prototype, {
  $eventHub: {
    get: function () {
      return EventBus
    }
  }
})

// Vue.prototype.$eventHub = new Vue();
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app > div')
